import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section-padding scroll-mt-24 bg-background-50">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="font-semibold text-xs tracking-widest uppercase mb-3 font-sans text-accent-600">
            Your Questions, Answered
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-sm leading-relaxed max-w-xl mx-auto">
            Everything you need to know about the <strong>Energy-Safe Method</strong> and what working together looks like.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200 overflow-hidden transition-all duration-200 bg-background-100"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer group"
                aria-expanded={openIndex === index}
                onClick={() => toggle(index)}
              >
                <span className="font-heading text-base font-semibold text-primary-800 group-hover:text-secondary-600 transition-colors leading-snug">
                  {item.question}
                </span>
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-all duration-300 bg-background-200 ${
                    openIndex === index ? "rotate-45" : ""
                  }`}
                >
                  <i className="ri-add-line text-sm text-foreground-600" />
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="px-6 pb-6 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-sm text-foreground-600 mb-4">
            Still have questions? The best way to get answers is a real conversation.
          </p>
          <a
            href="https://calendly.com/federicatedeschi3/new-meeting"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-primary-500 text-background-50 px-8 py-3.5 rounded-lg font-medium text-sm hover:bg-primary-600 hover:scale-[1.05] hover:-translate-y-[3px] hover:shadow-lg transition-all duration-300 ease-out whitespace-nowrap cursor-pointer"
          >
            Book a Free Conversation
          </a>
        </div>
      </div>
    </section>
  );
}